/* FOOTIX — galerie fiche produit (2026-09-13) : vignettes <-> piste d'images ; mobile = swipe lateral, compteur synchronise */
(function(){
  "use strict";
  function pad2(n){return (n<10?"0":"")+n;}
  function init(root){
    Array.prototype.slice.call((root||document).querySelectorAll("[data-ftx-product]:not([data-ftx-gal-init])")).forEach(function(el){
      el.setAttribute("data-ftx-gal-init","1");
      var track=el.querySelector("[data-ftx-gal-track]"); if(!track) return;
      var imgs=Array.prototype.slice.call(el.querySelectorAll("[data-ftx-gal-img]"));
      var thumbs=Array.prototype.slice.call(el.querySelectorAll("[data-ftx-thumb]"));
      var count=el.querySelector("[data-ftx-gal-count]");
      var reduced=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var cur=0;
      function mobile(){return window.matchMedia("(max-width:900px)").matches;}
      function mark(i){
        cur=i;
        if(count) count.textContent="View "+pad2(i+1)+" / "+pad2(imgs.length);
        thumbs.forEach(function(b,j){b.setAttribute("aria-current",j===i?"true":"false");});
        imgs.forEach(function(im,j){im.classList.toggle("on",j===i);});
      }
      function show(i){
        if(!imgs[i]) return;
        if(mobile()) track.scrollTo({left:i*track.clientWidth,behavior:reduced?"auto":"smooth"});
        mark(i);
      }
      thumbs.forEach(function(b,i){b.addEventListener("click",function(){if(cur!==i) show(i);});});
      var t=null;
      track.addEventListener("scroll",function(){
        if(!mobile()) return;
        window.clearTimeout(t);
        t=window.setTimeout(function(){
          var i=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));
          if(i!==cur&&imgs[i]) mark(i);
        },80);
      },{passive:true});
      window.addEventListener("resize",function(){ if(mobile()) track.scrollTo({left:cur*track.clientWidth,behavior:"auto"}); },{passive:true});
      mark(0);
    });
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",function(){init(document);}); else init(document);
  document.addEventListener("shopify:section:load",function(e){init(e.target);});
})();
